import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../redux/store";
import useCallApiAndLoad from "../../hooks/useCallApiAndLoad";
import { logoutEndpoint } from "../../services/publicService";
import { logoutAction } from "../../redux/features/auth";
import { unsetAuth } from "../../helpers/authHelper";
import { getAppPropiSpaPath } from "../../helpers/realmHelpers";
import Divider from "@mui/material/Divider";

const NavBarCustomer = () => {
  const user = useSelector((store: AppStore) => store.auth);
  const { country } = useSelector((store: AppStore) => store.country);
  const dispatch = useDispatch();
  const { callEndpoint } = useCallApiAndLoad();

  const handleLogout = async () => {
    const { token, rft, realm } = user;
    await callEndpoint(logoutEndpoint(token, rft, realm));
    dispatch(logoutAction({}));
    unsetAuth();
    if (typeof window !== "undefined") {
      return window.open(
        `${getAppPropiSpaPath()}/${country}/auth/login`,
        "_self"
      );
    }
  };
  return (
    <nav className="dropdown-menu bg-white lg:absolute lg:mt-[45px] lg:shadow-lg lg:rounded-[5px] w-full lg:w-fit lg:right-[15px] lg:z-[100] w-max">
      <ul className="w-max">
        <li className="w-fit">
          <ul className="w-fit">
            <li className="hover:bg-green200 hover:text-green700 text-[#212121] font-medium text-sm py-2 lg:pl-2 lg:pr-6 rounded-t-lg">
              <a href={`/app/${country}/l/ld/mi-cuenta`}>Mi cuenta</a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-blackScale text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6 rounded-t-lg">
              <a href={`${getAppPropiSpaPath()}/${country}/l/ld/payments`}>
                Mis Inversiones
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-blackScale text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/l/ld/pre-booking`}>
                Mis pre-reservas
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-blackScale text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/l/properties`}>
                Ofertas y propiedades
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-grayText text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/l/tn/offers`}>
                Ofertas realizadas
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-[#212121] font-medium text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/l/tn/visits`}>
                Mis visitas
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-grayText text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/l/tn/payments`}>
                Mis alquileres
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-grayText text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a
                href={`${getAppPropiSpaPath()}/${country}/l/tn/payments-sales`}
              >
                Mis compras
              </a>
            </li>
            <li className="hover:bg-green200 hover:text-green700 text-blackScale text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6">
              <a href={`${getAppPropiSpaPath()}/${country}/ayuda`}>
                Obtener ayuda
              </a>
            </li>
            <Divider />
            <li className="hover:bg-green200 hover:text-green700 text-blackScale text-sm lg:text-sm py-2 lg:pl-2 lg:pr-6 rounded-b-lg">
              <button onClick={handleLogout}>Cerrar sesión</button>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default NavBarCustomer;
